import React from "react";
import { Modal } from "antd";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { Icon } from "antd";

import { Parse } from "parse";
//Parse.initialize("6cev9RMB5Q36eXubFhT27zEzDJ9ZfCDDBJv87csPPYE62tAvKD");

class ModalSignOut extends React.Component {
  constructor(props) {
    super(props);
    this.state = { visible: false };

    this.handleCancel = this.handleCancel.bind(this);
  }

  showModal = () => {
    this.setState({
      visible: true
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false
    });
  };

  /*  handleDisconnect = (e) => {
  this.setState({
    visible: false,
    disconnect: true
  });
}
*/
  render() {
    const redirect = !this.props.user.login;
    if (redirect) {
      return <Redirect to="/" />;
    }

    return (
      <div style={{ marginTop: "5px" }}>
        <span
          style={{
            fontSize: "13px",
            fontWeight: "bold",
            color: "#0000FE",
            cursor: 'pointer'
          }}
          onClick={this.showModal}
        >
        <Icon type="logout" />
          {""} Me déconnecter
        </span>
        <Modal
          visible={this.state.visible}
          onCancel={this.handleCancel}
          onOk={this.props.handleDisconnect}
          okText="Oui"
          cancelText="Non !"
        >
          Voulez-vous vraiment vous déconnecter ?
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = globalReducers => globalReducers;

const mapDispatchToProps = dispatch => {
  return {
    handleDisconnect() {
      Parse.User.logOut();
      dispatch({ type: "disconnect" });
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalSignOut);

//module.exports = ModalSignOut
